var songlist = (function ($) {
	"use strict";
	var $songlist,
		init = function () {
			$songlist = $('#songlist');
			if ($songlist.length > 0) {
				songlist.main.init();
			}
		};
	$(document).ready(init);
	return {
		$: $,
		g: function () {
			return $songlist;
		}
	};
})(jQuery);

songlist.main = (function (parent) {
	"use strict";
	var $ = parent.$,
		$form,
		$input,
		$select,
		$alpha,
		$list,
		init = function () {
			$list = parent.g().find('.item');
			jQuery.expr[':'].startsWith = function (a, i, m) {
				//noinspection JSConstructorReturnsPrimitive
				var t = $(a).text().replace(/^\s*/, '').substring(0, 1);
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			jQuery.expr[':'].containsIC = function (a, i, m) {
				var t = $(a).text();
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			initSearch();
			initLinks();
		},
		initSearch = function () {
			$form = parent.g().find('form');
			$form.on('submit', function(e) {
				e.preventDefault();
			});
			$input = $form.find('input').keyup(function (e) {
				if ($(this).val().length >= 3) {
					//if (e.which == 13) { // Enter
					var t = this;
					doSearch.call(t);
					//}
				}
			});
			$select = $form.find('select').change(doSearch);
			$alpha = $('#alphabet').find('a').on('click touchstart', doSearch);
		},
		initLinks = function () {
			$('h2 a', $list).click(function(e){
				var $this = $(this),
					$parent = $this.parents('.item');
				e.preventDefault();
				$list.filter('open').not($this).removeClass('open');
				if (!$parent.hasClass('open')) {
					$parent.addClass('open');
				}
				else {
					$parent.removeClass('open');
				}
			});

			debugger;

			if (location.hash.length > 1) {
				$list.filter(location.hash).trigger('click');
			}
		},
		doSearch = function (e) {
			if (e) {
				e.preventDefault();
			}
			var $this = $(this);
			var t = this.tagName;
			if (t == 'SELECT') {
			}
			else if (t == 'INPUT') {
			}
			else {
				// t = a
				$alpha.removeClass('selected');
				$this.addClass('selected');
			}
			var searchValue = $input.val();
			var selectValue = $select.val();
			var alphaHref = $alpha.filter('.selected').attr('href');
			var selectedAlpha = (alphaHref) ? alphaHref.replace('#', '').substring(0, 1) : '';
			var $res = $list;
			if (selectValue) {
				$res = $res.filter('.' + selectValue);
			}
			if (selectedAlpha) {
				$res = $res.find('h2 a:startsWith("' + selectedAlpha + '")').parents('.item');
			}
			if (searchValue) {
				$res = $res.find(':containsIC("' + searchValue + '")').parent();
			}
			$list.removeClass('open');
			result($res);
		},
		result = function ($filtered) {
			if ($filtered) {
				$list.hide();
				$filtered.show();
			}
			else {
				$list.show();
			}
		};
	return {
		init: init
	};
})(songlist);
